import { ViewModel,View } from "binder"
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IPaymentMethod, singlePayment } from "../invoicePayment/invoicePayment-viewModel";
import  { CashPaymentView } from "./cashPayment-view"

export class CashPaymentViewModel extends ViewModel implements IPaymentMethod{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.paymentTypeName = 'نقدی';
    }

    GetDefaultView(): View <ViewModel> {
        return new CashPaymentView();
    }
    public getTypeId(): string {
        return "VM-A6F3BB5E-CB8E-43E5-B08C-ADD8471CFB44"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set paymentTypeName(v: string) { this._paymentTypeName = v; } public get paymentTypeName(): string { return this._paymentTypeName;} private _paymentTypeName: string;
    
    public set maxAmount(v: number) { 
        this._maxAmount = v; 
        if(this.maxAmount > 0)
            this.amount = this.maxAmount;
    } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { 
        this._amount = getAsNumber(v,true);
        // this.checkAmountValidity();
    } public get amount(): number { return this._amount;} private _amount: number;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set isFromRootDistrict(v: boolean) { this._isFromRootDistrict = v; } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    
    private checkAmountValidity(){
        if(this.amount>this.maxAmount){
            this.amount = this.maxAmount;
        }
    }    
    clear() {
        
    }
    load(){}
    public async createPayment(){
        let validationResult = this.validateInput();
        if(validationResult==''){
            try {
                this.isLoading = true;
                var confirmationResult = await this.messageBoxSuccessYesNo(`آیا پرداخت با مبلغ ${this.amount} صحیح است؟`,'پرداخت نقدی');
                if(confirmationResult=='no'){
                    return;
                }
                let result = await ServerConnection.callServer('/Complex/SellServices/AddCashPayment',{
                    InvoiceId:this.invoiceId,
                    Amount:this.amount
                });
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess('پرداخت با موفقیت ثبت شد','پرداخت نقدی');
                    var payment = new singlePayment(this.parentViewModel);
                    payment.setConfirmationStatus(true);
                    payment.method = 'نقدی';
                    payment.amount = this.amount;
                    payment.time = moment.utc(moment.now());
                    this.onNewPaymentCreated(payment);
                } else {
                if (result.Faults[0].Parameters.FaultId === "8E9EEFBC-C6A3-4088-B60A-E1B649EE679A"){
                    throw "زمان یا مبلغ اعتبار مشتری یه پایان رسیده است. لطفا پرداخت را برای فاکتورهای نهایی شده وی انجام دهید.";
                }else if (result.Faults[0].Parameters.FaultId === "6CFFE6CC-63FC-4C3D-8976-6E1677020051")
                    throw "مانده حساب بیشتر از اعتبار مشتری است.";
                throw "خطا در انجام عملیات";
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(ex,"خطا")
            } finally {
                this.isLoading = false;
            }
        }else{
            await this.messageBoxConfirmWarning(validationResult,"خطا")
        }
    }

    private validateInput():string{
        let errors :string[]= []
        if(this.amount<=0){
            errors.push('مبلغ به درستی تنظیم نشده است');
        }
        return errors.join("\n");
    }

    onNewPaymentCreated(payment: singlePayment) {
    }
}
